import React, { useCallback, useEffect, useState } from 'react';
import { Button, Text } from '@rsos/base-components';
import { StyledDebugMenu } from './DebugMenu.styles';
import { usePanels } from './DebugPanelContext';

interface DebugMenuProps {
  onError?: (error: string) => void;
}

const DEBUG_MENU_HOT_KEY = 'ALT+SHIFT+D';

const DebugMenu: React.FC<DebugMenuProps> = ({ onError }) => {
  const panels = usePanels();
  const [isDebugPanelVisible, setIsDebugPanelVisible] = useState(false);
  const [activePanel, setActivePanel] = useState<string | null>(null);
  const onClose = () => {
    setActivePanel(null);
  };

  const toggleVisible = useCallback(
    (e: KeyboardEvent) => {
      // NOTE: if you update the key update DEBUG_MENU_HOT_KEY
      if (e.altKey && e.shiftKey && e.code === 'KeyD') {
        setIsDebugPanelVisible(v => !v);
        e.preventDefault();
        e.stopPropagation();
      }
    },
    [setIsDebugPanelVisible],
  );

  useEffect(() => {
    if (panels.length > 0) {
      window.addEventListener('keydown', toggleVisible);
    }
    return () => {
      window.removeEventListener('keydown', toggleVisible);
    };
  }, [toggleVisible, panels.length]);

  if (panels.length === 0 || !isDebugPanelVisible) {
    return null;
  }

  return (
    <StyledDebugMenu>
      <Text size="small" color="primaryText">
        DEBUG MENU
        <br />({DEBUG_MENU_HOT_KEY} to hide)
      </Text>
      {panels.map(panel => (
        <div key={panel.id}>
          <Button
            onClick={() => setActivePanel(panel.id)}
            btnType="tertiary"
            noMargin
          >
            {panel.label}
          </Button>
          {panel.id === activePanel &&
            panel.component({
              onError,
              onClose,
            })}
        </div>
      ))}
    </StyledDebugMenu>
  );
};

export default DebugMenu;
